import { atom, useAtomValue, useSetAtom } from 'jotai';

const graphqlSubscriptionConnection = atom(false);

export const useSetGraphqlSubscriptionConnection = () =>
  useSetAtom(graphqlSubscriptionConnection);
export const useGraphqlSubscriptionConnection = () =>
  useAtomValue(graphqlSubscriptionConnection);
